import isSvgUrl from './isSvgUrl';
export default function getOptimizedUrl(url, dimension, size, quality, disableRetina, supportsWebp) {
  if (!isSvgUrl(url)) {
    let format = '';
    if (supportsWebp) {
      format = 'fm=webp';
    } else if (url.match(/\.jpe?g$/i)) {
      format = 'fm=jpg&fl=progressive';
    }
    let optimizedUrl = `${url}?${dimension}=${size}&q=${quality}&${format}`;
    if (!disableRetina) {
      optimizedUrl += `, ${url}?${dimension}=${size * 2}&q=${quality}&${format} 2x`;
    }
    return optimizedUrl;
  }
  return url;
}